import styled from 'styled-components';
import tw from 'twin.macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const GalleryStyled = styled.div`
  ${tw`my-5 lg:mt-0 relative`}
  max-width: 856px;

  h2 {
    ${tw`text-white text-2xl font-bold mb-6 my-6 lg:-mt-3`}
    font-size: 32px;
  }
`;

export const GalleryThumbsStyled = styled.div`
  ${tw`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 xl:gap-5 mb-20`}

  .trailer-item {
    ${tw`relative mx-auto`}

    > div {
      width: 135px !important;
      height: 135px !important;

      @media (min-width: ${fullConfig.theme.screens.md}) {
        width: 196px !important;
        height: 196px !important;
      }
    }

    .video-play {
      ${tw`absolute inset-0 outline-none`}
      width: 135px !important;
      height: 135px !important;

      @media (min-width: ${fullConfig.theme.screens.md}) {
        width: 196px !important;
        height: 196px !important;
      }

      background: transparent;
      transition: all 300ms ease-in-out;

      &:hover,
      &:focus {
        transition: all 300ms ease-in-out;
        background: radial-gradient(
          circle,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0) 40%,
          rgba(0, 0, 0, 0.5) 100%
        );
      }
    }
  }

  .gallery-item {
    transition: all 300ms ease-in-out;

    > div {
      width: 135px !important;
      height: 135px !important;

      @media (min-width: ${fullConfig.theme.screens.md}) {
        width: 196px !important;
        height: 196px !important;
      }
    }

    &:hover,
    &:focus {
      filter: brightness(1.5);
    }
  }
`;
